import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import pluralize from 'pluralize';

import './page_header.scss';

export default class PageHeader extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    iconDescription: PropTypes.string,
    iconName: PropTypes.object,
    iconPath: PropTypes.string,
    iconSize: PropTypes.string,
    iconText: PropTypes.string.isRequired,
    iconType: PropTypes.oneOf(['icon', 'img']),
    lg: PropTypes.any,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      itemSingularLabel: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired
    })
  };

  displayCount = () => {
    const { currentPage, itemCount, itemSingularLabel, pageSize, totalCount } = this.props.pageData;

    if (totalCount === 0) return `No ${pluralize(itemSingularLabel)} found`;

    const itemCountLabel = pluralize(itemSingularLabel, totalCount, true);

    if (totalCount <= pageSize) return `Displaying ${itemCountLabel}`;

    const lowerBound = (currentPage - 1) * pageSize + 1;
    const upperBound = lowerBound + itemCount - 1;
    return `Displaying <strong>${lowerBound} - ${upperBound}</strong> of <strong>${totalCount}</strong>`;
  };


  render() {
    return (
      <div className={classNames('page-header-row-container', this.props.className, { lg: this.props.lg })}>
        <div className="page-header-row">
          <div className="mr-2">{ this.renderIcon() }</div>
          { this.renderLabel() }
          {this.renderDescription()}
          <div className="page-header-children">
            { this.props.children }
          </div>
        </div>
      </div>
    );
  }

  renderDescription() {
    return (
      <div className="page-description">
        { this.props.pageData
          ? this.renderPageCount()
          : <small className="hidden-sm hidden-xs">
            { this.props.iconDescription }
          </small>
        }
      </div>
    );
  }

  renderPageCount() {
    if (!this.props.pageData) return null;

    return (
      <div className="pt-1 hidden-xs hidden-sm" name="page_count">
        <span className="text-muted" dangerouslySetInnerHTML={{ __html: this.displayCount() }} />
      </div>
    );
  }

  renderIconFromFont = () => {
    return (
      <FontAwesomeIcon icon={this.props.iconName} size={this.props.iconSize} />
    );
  }

  renderIconFromAsset = () => {
    if (this.props.iconPath) {
      return <img src={this.props.iconPath} />;
    }
  }

  renderIcon() {
    switch (this.props.iconType) {
    case 'icon':
      return this.renderIconFromFont();
    case 'img':
      return this.renderIconFromAsset();
    default:
      return null;
    }
  }

  renderLabel() {
    return (
      <h2
        className={classNames('page-title', {
          'with-padding': !!(this.props.iconName || this.props.iconPath),
          'with-description': !!this.props.iconDescription || !!this.props.pageData
        })}
      >
        { this.props.iconText }
      </h2>
    );
  }
}
